import type { BookingField } from "types";
import { isEmailVerificationEnforced } from "@/utils/emailVerificationConfig";

/**
 * Corrected visibility for SEPA mandate booleans. CMS historically used
 * `!= null || != ""`, which is true for `null` (`null != ""`), inverting visibility.
 * Prefer pasting these snippets into CMS so all clients stay consistent.
 */
const SEPA_MANDATE_CONDITIONS = `covomoBookingFieldConfig = function (tariff, form) {
  var n = tariff && tariff.alternative_creditor_name;
  var hasAlt = n != null && String(n).trim() !== "";
  return { isVisible: true, isBookingVisible: !hasAlt, isDisabled: false };
};`;

const ALTERNATIVE_CREDITOR_SEPA_MANDATE_CONDITIONS = `covomoBookingFieldConfig = function (tariff, form) {
  var n = tariff && tariff.alternative_creditor_name;
  var hasAlt = n != null && String(n).trim() !== "";
  return { isVisible: true, isBookingVisible: hasAlt, isDisabled: false };
};`;

const VERIFICATION_NOT_REQUIRED_ENFORCED_CONDITIONS = `covomoBookingFieldConfig = function (tariff, form) {
  return { isVisible: false, isBookingVisible: false, isDisabled: true };
};`;

/** Conditions string passed to eval() for booking field visibility. */
export function conditionsForBookingFieldEval(field: BookingField): string {
  if (field.field_name === "verification_not_required") {
    if (isEmailVerificationEnforced()) {
      return VERIFICATION_NOT_REQUIRED_ENFORCED_CONDITIONS;
    }
  }
  if (field.field_name === "sepa_mandate") return SEPA_MANDATE_CONDITIONS;
  if (field.field_name === "alternative_creditor_sepa_mandate") {
    return ALTERNATIVE_CREDITOR_SEPA_MANDATE_CONDITIONS;
  }
  return typeof field.conditions === "string"
    ? field.conditions
    : String(field.conditions ?? "");
}
